export default __webpack_public_path__ + "static/media/mccarty-photo.25c7bb70.jpeg";